var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"dompurify-html",rawName:"v-dompurify-html",value:(_vm.message),expression:"message"}]})
}
var staticRenderFns = []

export { render, staticRenderFns }